<template>
  <div id="app8">
      <header>
        <Navbar/>
      </header>
  </div>
</template>

<script>
import Navbar from './components/Navbar';

export default {
  name: 'AppNav',
  components: {
    Navbar,
  }
}
</script>
